// src/services/formComplaintsService.js
import apiClient from './apiClient';

const formComplaintsService = {
  // Enviar un nuevo formulario de quejas/sugerencias
  submitForm: async (formData) => {
    try {
      console.log('Enviando formulario al backend:', JSON.stringify(formData, null, 2));
      const response = await apiClient.post('/', formData);
      console.log('Respuesta del backend:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error al enviar formulario:', {
        status: error.response?.status,
        message: error.response?.data?.message || error.message,
        data: error.response?.data
      });
      throw error;
    }
  },

  // Obtener el primer formulario pendiente y marcarlo como activo
  getFirstPendingForm: async () => {
    try {
      const response = await apiClient.get('/forms/pending');
      console.log('Formulario pendiente obtenido:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error al obtener formulario pendiente:', {
        status: error.response?.status,
        message: error.response?.data?.message || error.message
      });
      throw error;
    }
  },

  // Agregar mensaje a un formulario existente
  addMessageToForm: async (formId, message) => {
    try {
      if (!message || message.trim() === '') {
        throw new Error('El mensaje no puede estar vacío');
      }

      console.log(`Agregando mensaje al formulario ${formId}:`, message);
      const response = await apiClient.post(`/forms/addMessage/${formId}`, {
        message: message.trim()
      });
      console.log('Mensaje agregado exitosamente:', response.data);
      return response.data;
    } catch (error) {
      console.error(`Error al agregar mensaje al formulario ${formId}:`, {
        status: error.response?.status,
        message: error.response?.data?.message || error.message,
        data: error.response?.data
      });
      throw error;
    }
  },

  // Finalizar un formulario con mensaje opcional
  finalizeForm: async (formId, finalMessage = '', idCard = '') => {
    try {
      console.log(`Finalizando formulario ${formId} con mensaje:`, finalMessage);
      const response = await apiClient.put('/forms/finalizeForm', {
        finalMessage: finalMessage.trim(),
        idCard: idCard.trim() 
      }, {
        params: { id: formId }
      });
      console.log('Formulario finalizado exitosamente:', response.data);
      return response.data;
    } catch (error) {
      console.error(`Error al finalizar formulario ${formId}:`, error);
      throw error;
    }
  },



  // Obtener todos los formularios con filtros opcionales
  getAllForms: async (filters = {}) => {
    try {
      const response = await apiClient.get('/forms/getAllForms', {
        params: filters
      });
      return response.data;
    } catch (error) {
      console.error('Error al obtener formularios:', error);
      throw error;
    }
  },

  // Obtener formulario por ID
  getFormById: async (formId) => {
    try {
      const response = await apiClient.get(`/forms/${formId}`);
      console.log(`Formulario ${formId} obtenido:`, response.data);
      return response.data;
    } catch (error) {
      console.error(`Error al obtener formulario ${formId}:`, error);
      throw error;
    }
  },

  // Actualizar estado de un formulario
  updateFormStatus: async (formId, status) => {
    try {
      const response = await apiClient.put(`/forms/${formId}/status`, {
        status
      });
      console.log(`Estado del formulario ${formId} actualizado a ${status}:`, response.data);
      return response.data;
    } catch (error) {
      console.error(`Error al actualizar estado del formulario ${formId}:`, error);
      throw error;
    }
  }
};

export default formComplaintsService;